export type VttCue = { startTime: number; endTime: number; text: string }

function parseVttTimestamp(ts: string): number {
  const parts = ts.trim().split(':')
  if (parts.length === 3) {
    const [h, m, s] = parts
    return parseInt(h, 10) * 3600 + parseInt(m, 10) * 60 + parseFloat(s)
  }
  if (parts.length === 2) {
    const [m, s] = parts
    return parseInt(m, 10) * 60 + parseFloat(s)
  }
  return 0
}

export function parseVtt(text: string): VttCue[] {
  const cues: VttCue[] = []
  const blocks = text.replace(/\r\n/g, '\n').split(/\n\n+/)
  for (const block of blocks) {
    const lines = block.trim().split('\n')
    const timingIdx = lines.findIndex((l) => l.includes('-->'))
    if (timingIdx === -1) continue
    const [startStr, endStr] = lines[timingIdx].split('-->')
    if (!startStr || !endStr) continue
    const startTime = parseVttTimestamp(startStr)
    const endTime = parseVttTimestamp(endStr)
    const text = lines
      .slice(timingIdx + 1)
      .join(' ')
      .trim()
    if (text) {
      cues.push({ startTime, endTime, text })
    }
  }
  return cues
}
